import { IMessageProcessor } from '../types';

export const userIdProcessor: IMessageProcessor = (currentMessage) => {
    currentMessage.user_id = currentMessage.user ? currentMessage.user.user_id : 'bot';
};
